import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LoadingPage from "../pages/LoadingPage.tsx";

interface Props {
  // Megváltoztatjuk a típust, hogy függvényt is fogadhasson
  children: (location: any) => React.ReactNode;
}

const RouteTransitionWrapper: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState("IDLE");
  
  useEffect(() => {
    // Ha az URL megváltozik a címsorban, de mi még a régit mutatjuk
    if (location.pathname !== displayLocation.pathname) {
      // 1. Megjelenítjük a LoadingPage-et a régi tartalom felett
      setTransitionStage("LOADING");

      // 2. Késleltetjük a tényleges komponens-cserét (pl. 800ms)
      // Ez alatt a LoadingPage animációja már javában fut
      const timer = setTimeout(() => {
        setDisplayLocation(location); // Most váltunk át az új oldalra a háttérben
        setTransitionStage("FINISHING");
      }, 800); 

      return () => clearTimeout(timer);
    }
  }, [location, displayLocation.pathname]);

  useEffect(() => {
    if (transitionStage === "FINISHING") {
      // 3. Miután az új oldal beugrott a LoadingPage mögé, várunk még, 
      // amíg a LoadingPage elvégzi a saját eltűnő animációját
      const timer = setTimeout(() => {
        setTransitionStage("IDLE");
      }, 1200); 
      return () => clearTimeout(timer);
    }
  }, [transitionStage]);

  return (
    <>
      {/* A LoadingPage kint van, amíg nem IDLE az állapot */}
      {transitionStage !== "IDLE" && <LoadingPage />}
      
      <div 
        style={{ 
          opacity: transitionStage === "IDLE" ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
          visibility: transitionStage === "IDLE" ? "visible" : "hidden"
        }}
      >
        {/* Itt hívjuk meg a gyermekeket a késleltetett helyszínnel */}
        {children(displayLocation)}
      </div>
    </>
  );
};

export default RouteTransitionWrapper;